module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('app-page-header'), _vm._v(" "), _c('div', {
    staticClass: "box competo-iframe-box"
  }, [_c('iframe', {
    staticClass: "competo-iframe",
    attrs: {
      "src": _vm.linkProtocoloCompeto,
      "frameborder": "0"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a8f4dd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/pessoal/components/Protocolo.vue
// module id = 535
// module chunks = 2